.header {
  --app-header-padding-inline-min: 5%;
  --app-header-content-max-width: 100rem;
  .sd-navigation-menu__content {
    outline: var(--sd-border-2) var(--sd-color-focusVisible-outline);
  }

  :global(
    .sd-user-menu
      span[aria-hidden='true']:focus-visible
      + .sd-navigation-menu__content
  ) {
    outline: var(--sd-border-2) var(--sd-color-focusVisible-outline);
  }
}
